<template>
  <box>
    <data-table
      ref="table"
      sort-by="created_at"
      sort-desc
      :items="fetchActivities"
      :theme="theme"
      :per-page="20"
    >
      <!-- Time Column -->
      <data-column
        field="created_at"
        :label="$t('time')"
      >
        <template slot-scope="{ value }">
          <span>{{ value ? formatDate(value) : '-' }}</span>
        </template>
      </data-column>

      <!-- User Column -->
      <data-column
        field="user.email"
        :label="$t('user')"
      >
        <template slot-scope="{ value }">
          <span>{{ value || '-' }}</span>
        </template>
      </data-column>

      <!-- IP Address Column -->
      <data-column
        field="ip_address"
        label="IP"
      >
        <template slot-scope="{ value }">
          <span>{{ value || '-' }}</span>
        </template>
      </data-column>

      <!-- Description Column -->
      <data-column
        field="description"
        :label="$t('description')"
      >
        <template slot-scope="{ value }">
          <span>{{ value || '-' }}</span>
        </template>
      </data-column>

      <!-- Method Column -->
      <data-column
        field="method"
        label="Method"
      >
        <template slot-scope="{ value }">
          <span>{{ value || '-' }}</span>
        </template>
      </data-column>

      <!-- Endpoint Column -->
      <data-column
        field="endpoint"
        :label="$t('endpoint')"
      >
        <template slot-scope="{ value }">
          <span>{{ value || '-' }}</span>
        </template>
      </data-column>

      <!-- Status Column -->
      <data-column
        field="status_code"
        label="Status"
      >
        <template slot-scope="{ value }">
          <span>{{ value || '-' }}</span>
        </template>
      </data-column>
    </data-table>
  </box>
</template>

<script>
import { DataTable, DataColumn } from '@cyradar/ui'
import { format } from 'date-fns'

export default {
  name: 'UserActivitiesTable',
  components: {
    DataTable,
    DataColumn
  },
  props: {
    theme: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Format date to dd/MM/yyyy HH:mm:ss format
     */
    formatDate(value) {
      if (!value) return '-'
      try {
        const date = new Date(value)
        return format(date, 'dd/MM/yyyy HH:mm:ss')
      } catch (error) {
        console.warn('Error formatting date:', error)
        return value
      }
    },
    
    /**
     * Fetches user activities data from API
     */
    fetchActivities(filter, sort, pagination) {
      return this.$http.get(`/api/v1/users/activities?page=${pagination.page}&limit=${pagination.perPage}&query=${filter.query}&sort=${sort.by}&order=${sort.order}`)
        .then(body => {
          if (!body) {
            return {
              total: 0,
              items: []
            }
          }
          return body.data
        })
        .then(data => {
          if (!data || !data.data) {
            return {
              total: 0,
              items: []
            }
          }

          if (data.data.total === 0) {
            return {
              total: 0,
              items: []
            }
          }

          return data.data
        })
        .catch(error => {
          console.error('Error fetching activities:', error)
          return {
            total: 0,
            items: []
          }
        })
    }
  }
}
</script>
